import { useTranslation } from "react-i18next";

import { RequireCapability } from "@/components/RequireCapability";

import { BillingInformationForm } from "./BillingInformationForm";
import { PaymentCard } from "./PaymentCard";
import { SubscriptionSummary } from "./SubscriptionSummary";

/**
 * Billing & subscription area. Reached contextually from the subscription flow
 * (no top-level nav link). Composes three pieces:
 *  - billing information (autosaved form),
 *  - a Stripe Elements card input (SetupIntent),
 *  - the subscription summary (plan/price/discounts/total, confirm/cancel).
 *
 * Guarded so only authenticated users reach it.
 */
export function BillingPage() {
  const { t } = useTranslation();
  return (
    <RequireCapability required={["authenticated"]}>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">{t("billing.title")}</h1>
          <p className="mt-1 text-muted-foreground">{t("billing.subtitle")}</p>
        </div>

        <div className="grid items-start gap-6 lg:grid-cols-2">
          <div className="space-y-6">
            <BillingInformationForm />
            <PaymentCard />
          </div>
          <div className="lg:sticky lg:top-20">
            <SubscriptionSummary />
          </div>
        </div>
      </div>
    </RequireCapability>
  );
}
